import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "&store/store";
import { useHistory } from "react-router-dom";
import { loginActions } from "&features/login/login.slice";
import { usersActions } from "&features/users/users.slice";

type ReduxProps = ConnectedProps<typeof connector>;

const LogoutComponent = (props: ReduxProps) => {
  const history = useHistory();
  const { logout, logoutUser } = props;

  useEffect(() => {
    const doLogout = async () => {
      await logoutUser("");
      logout();
      history.push("/login");
    };
    doLogout();
  }, [history, logout, logoutUser]);

  return <div />;
};

/**
 * Maps state variables from redux store to props of currect component
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
  // Map your redux state to your props here
});

/**
 * Maps actions from slices to props
 */
const mapDispatchToProps = {
  logout: loginActions.reset,
  logoutUser: usersActions.logoutUser,
};

/**
 * Connects component to redux store
 */
const connector = connect(mapStateToProps, mapDispatchToProps);
const LogoutComponentRedux = connector(LogoutComponent);

export { LogoutComponentRedux as LogoutComponent };
